module.exports = __webpack_public_path__ + "static/media/6.567544d5.jpg";